import { Base } from "src/app/shared/model/core/base.model";

export class SeguimientoProspeccion extends Base {

    public id_seguimiento: number;
	public id_prospeccion: number;
	public fecha: Date;
	public actividad: string;
	public compromiso: Date;
	public fechaSigSeguimiento: string;
    public nota: string;
    public responsable: string;
    public estatus: number;
    public observaciones: string;
    public id_usuario: number;
    public titulo_seguimiento: string;

}